import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"

const Hero = () => {
  return (
    <section className="hero_section">
      <div className="container">
        <div className="hero_wrapper">
          
          <div className="hero_details">
            <div className="texts">
              <h1>Welcome</h1>
              <p><strong>Practype</strong> Small Design Studio based on <strong>Yogyakarta, Indonesia.</strong> We are a team of lettering artists, type designers, and graphic designers. We love good things and great design.</p>              </div>
            <div className="btn-lnks">
              <div className="dwn-links">
              <a href="https://www.creativefabrica.com/designer/practype/ref/236675" target="blank" className="btn btn-download">
                <h4>Shop Now!</h4>
                <span>Creative Fabrica</span>
              </a>
              </div>

              <div className="dwn-links">
              <a href="https://www.dafont.com/eko-samp.d7910" target="blank" className="btn btn-coffee">
                <h4>Free Fonts</h4>
                <span>Freebies For You</span>
              </a>
              </div>
            </div>
            <div className="license">
              <p>Download best fonts for commercial use. We have script fonts, display fonts, brush fonts, calligraphy fonts, and more.</p>
            </div>
            
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
